import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getRecentBusiness = async (page = 1, limit = 10, city = '', category = '') => {
  const params = new URLSearchParams({ page, limit });
  if (city) params.set('city', city);
  if (category && category !== 'All') params.set('category', category);
  const res = await axios.get(`${API}/business?${params.toString()}`);
  return res.data;
};

export const searchBusiness = async (query, city, page = 1, limit = 10, category = '') => {
  const params = new URLSearchParams({ q: query, city, page, limit });
  if (category && category !== 'All') params.set('category', category);
  const res = await axios.get(`${API}/search?${params.toString()}`);
  return res.data;
};

export const getNearbyBusiness = async (lat, lng) => {
  const res = await axios.get(`${API}/nearby?lat=${lat}&lng=${lng}`);
  return res.data;
};

export const addBusiness = async (data) => {
  const res = await axios.post(`${API}/business`, data);
  return res.data;
};

// Used by BusinessPage — returns business + reviews in one call
export const getBusinessBySlug = async (slug) => {
  const res = await axios.get(`${API}/business/slug/${encodeURIComponent(slug)}`);
  return res.data;
};

// Used by CityPage hub — reuses the existing /business endpoint
export const getBusinessesByCity = async (city, page = 1, limit = 50) => {
  const params = new URLSearchParams({ page, limit, city });
  const res = await axios.get(`${API}/business?${params.toString()}`);
  return res.data;
};

// Used by CategoryPage hub — reuses the existing /business endpoint
export const getBusinessesByCategory = async (category, page = 1, limit = 50) => {
  const params = new URLSearchParams({ page, limit, category });
  const res = await axios.get(`${API}/business?${params.toString()}`);
  return res.data;
};